import {
  CheckCircle,
  User,
  FileType,
  MessageSquare,
  Calendar,
  Download,
  Eye,
  XCircle,
} from "lucide-react";

const CompletedRequestsTab = ({
  t,
  styles,
  screenSize,
  completedRequests,
  isLoading,
  language,
  canDownloadDocuments,
  canViewDocuments,
  onDownload,
  onPreview,
}) => {
  if (isLoading) {
    return (
      <div style={styles.emptyState}>
        <CheckCircle
          size={screenSize.isMobile ? 48 : 64}
          style={{ marginBottom: "20px", opacity: 0.3 }}
        />
        <h3 style={styles.emptyStateTitle}>{t.loading}</h3>
      </div>
    );
  }

  if (completedRequests.length === 0) {
    return (
      <div style={styles.emptyState}>
        <CheckCircle
          size={screenSize.isMobile ? 48 : 64}
          style={{ marginBottom: "20px", opacity: 0.3 }}
        />
        <h3 style={styles.emptyStateTitle}>{t.noCompletedRequests}</h3>
        <p style={styles.emptyStateDesc}>{t.noCompletedDesc}</p>
      </div>
    );
  }

  return (
    <>
      {completedRequests.map((request) => (
        <div key={request.id} style={styles.requestCard}>
          <div style={styles.requestHeader}>
            <div style={styles.requestInfo}>
              <h4 style={styles.employeeName}>
                <User size={screenSize.isMobile ? 16 : 18} />
                {(language === "ar"
                  ? request.employee?.arabicName || request.employee?.sr
                  : request.employee?.sr || request.employee?.arabicName) || t.unknownEmployee}
              </h4>

              <p style={styles.requestDetail}>
                <span style={styles.detailLabel}>
                  <FileType size={14} />
                  {t.type}:
                </span>
                <span style={styles.badge}>
                  {request.requestType?.startsWith("upload:")
                    ? `📤 ${request.requestType.replace("upload:", "")}`
                    : request.requestType}
                </span>
              </p>

              {request.recipient &&
                !request.requestType?.startsWith("upload:") && (
                  <p style={styles.requestDetail}>
                    <span style={styles.detailLabel}>
                      <User size={14} />
                      {t.recipient}:
                    </span>
                    {request.recipient}
                  </p>
                )}

              <p style={styles.requestDetail}>
                <span style={styles.detailLabel}>
                  <Calendar size={14} />
                  {t.requestedDate}:
                </span>
                {new Date(
                  request.requestedDate || request.created_at
                ).toLocaleDateString(language === "ar" ? "ar-EG" : "en-US")}
              </p>

              <p style={styles.requestDetail}>
                <span style={styles.detailLabel}>
                  {request.status === "rejected" ? (
                    <XCircle size={14} color="#ef4444" />
                  ) : (
                    <CheckCircle size={14} />
                  )}
                  {request.status === "rejected" ? t.rejectedDate : t.completedDate}:
                </span>
                {new Date(request.processedDate).toLocaleDateString(
                  language === "ar" ? "ar-EG" : "en-US"
                )}
              </p>

              {request.comments && (
                <p style={styles.requestDetail}>
                  <span style={styles.detailLabel}>
                    <MessageSquare size={14} />
                    {t.comments}:
                  </span>
                  {request.comments}
                </p>
              )}
            </div>

            <div style={styles.actionButtons}>
              {canDownloadDocuments && request.generatedFileId && (
                <button
                  style={styles.downloadButton}
                  onClick={() => onDownload(request.generatedFileId)}
                >
                  <Download size={16} />
                  {t.download}
                </button>
              )}
              {canViewDocuments && request.generatedFileId && (
                <button
                  style={styles.previewButton}
                  onClick={() => onPreview(request.generatedFileId)}
                >
                  <Eye size={16} />
                  {t.preview}
                </button>
              )}
            </div>
          </div>
        </div>
      ))}
    </>
  );
};

export default CompletedRequestsTab;